import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_empire-lawn-quote/artifacts/k10girhv_Empire%20Lawn%20Care%20and%20Maintenance%20logo%202024.png";

export default function Navbar({ onGetQuote }) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white shadow-lg py-2'
          : 'bg-white/95 backdrop-blur-sm py-4'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a
            href="#hero"
            onClick={(e) => { e.preventDefault(); scrollToSection('hero'); }}
            className="flex items-center"
            data-testid="nav-logo"
          >
            <img
              src={LOGO_URL}
              alt="Empire Lawn Care and Maintenance"
              className="h-12 sm:h-14 w-auto"
            />
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('services')}
              className="font-inter text-gray-700 hover:text-green-900 transition-colors font-medium"
              data-testid="nav-services"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('how-we-operate')}
              className="font-inter text-gray-700 hover:text-green-900 transition-colors font-medium"
              data-testid="nav-how-we-operate"
            >
              How We Operate
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="font-inter text-gray-700 hover:text-green-900 transition-colors font-medium"
              data-testid="nav-contact"
            >
              Contact
            </button>
            <Button
              onClick={onGetQuote}
              className="bg-green-900 hover:bg-green-800 text-white font-oswald font-medium px-6 py-2 rounded-md btn-empire"
              data-testid="nav-get-quote-btn"
            >
              Get a Quote
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 text-gray-700 hover:text-green-900"
            data-testid="mobile-menu-btn"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-100 pt-4 animate-fade-in-up" data-testid="mobile-menu">
            <div className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection('services')}
                className="font-inter text-gray-700 hover:text-green-900 transition-colors font-medium text-left"
                data-testid="mobile-nav-services"
              >
                Services
              </button>
              <button
                onClick={() => scrollToSection('how-we-operate')}
                className="font-inter text-gray-700 hover:text-green-900 transition-colors font-medium text-left"
                data-testid="mobile-nav-how-we-operate"
              >
                How We Operate
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="font-inter text-gray-700 hover:text-green-900 transition-colors font-medium text-left"
                data-testid="mobile-nav-contact"
              >
                Contact
              </button>
              <div className="flex flex-col space-y-2 pt-2">
                <a
                  href="tel:0421441364"
                  className="flex items-center text-green-900 font-medium"
                >
                  <Phone size={16} className="mr-2" />
                  Lawn Care: 0421 441 364
                </a>
                <a
                  href="tel:0401226517"
                  className="flex items-center text-green-900 font-medium"
                >
                  <Phone size={16} className="mr-2" />
                  Cleaning: 0401 226 517
                </a>
              </div>
              <Button
                onClick={() => { setIsMobileMenuOpen(false); onGetQuote(); }}
                className="bg-green-900 hover:bg-green-800 text-white font-oswald font-medium w-full"
                data-testid="mobile-get-quote-btn"
              >
                Get a Quote
              </Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
